import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const pharmacyInventoryApi = createApi({
  reducerPath: "pharmacyInventoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/pharmacy-inventory/`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token || localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["PharmacyInventory"],
  endpoints: (builder) => ({
    getPharmacyInventory: builder.query({
      query: (params) => ({
        url: "",
        params,
      }),
      providesTags: ["PharmacyInventory"],
    }),
    addPharmacyItem: builder.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PharmacyInventory"],
    }),
    updatePharmacyItem: builder.mutation({
      query: ({ id, data }) => ({
        url: id,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["PharmacyInventory"],
    }),
    deletePharmacyItem: builder.mutation({
      query: (id) => ({
        url: id,
        method: "DELETE",
      }),
      invalidatesTags: ["PharmacyInventory"],
    }),
    togglePharmacyItemStatus: builder.mutation({
      query: (id) => ({
        url: `${id}/status`,
        method: "PATCH",
      }),
      invalidatesTags: ["PharmacyInventory"],
    }),
  }),
});

export const {
  useGetPharmacyInventoryQuery,
  useAddPharmacyItemMutation,
  useUpdatePharmacyItemMutation,
  useDeletePharmacyItemMutation,
  useTogglePharmacyItemStatusMutation,
} = pharmacyInventoryApi;
